module.exports = __webpack_public_path__ + "static/media/1.74770d95.JPG";